import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ASSISTANT_AUTH_RESET_PASSWORD_URL } from '../constants'; // ✅ Usa la constante

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        try {
            const res = await axios.post(ASSISTANT_AUTH_RESET_PASSWORD_URL, {
                token,
                password
            });

            console.log('✅ Respuesta del servidor:', res.data);
            setSuccess('Contraseña actualizada correctamente. Redirigiendo al login...');
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            console.error('❌ Error al actualizar la contraseña:', err);
            setError('No se pudo actualizar la contraseña. El enlace puede haber expirado.');
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white shadow-md rounded-lg">
                <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">Restablecer contraseña</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Nueva contraseña</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Confirmar contraseña</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700"
                    >
                        Actualizar contraseña
                    </button>
                </form>

                {success && <p className="mt-4 text-green-600 text-sm text-center">{success}</p>}
                {error && <p className="mt-4 text-red-600 text-sm text-center">{error}</p>}
            </div>
        </div>
    );
};

export default ResetPassword;
